/**
 * ─── [P7B.1] TEMPLATE-SET VALUES BOTH SIDES READ ─────────────────────────────────────────────
 *
 * The decision code for a force row whose source the booklet left blank. The server decides it as a
 * `SOURCE` code like any other; the web reads it to say "No source printed" rather than "(none)".
 *
 * ⚠️ ONE SPELLING, MOVED HERE FROM `api/src/utils/templateDecision.util.ts`, which re-exports it. The
 * import's planner keeps its own `SOURCE_NONE_CODE` — the import is frozen by [P7B.1] §5, and a test
 * holds the two equal rather than an edit to a file this pass may not touch.
 *
 * Runtime values only (no zod): `pwa` and `client-core` may import this barrel.
 */
export const TEMPLATE_SOURCE_NONE = '(none)';
